// @ts-nocheck

export const SHUTDOWN_MODE = {
  Threshold75: 'threshold_75',
  ThresholdCustom: 'threshold_custom',
  TimeBased: 'time_based',
} as const;

export type VoteRoomShutdownMode = (typeof SHUTDOWN_MODE)[keyof typeof SHUTDOWN_MODE];
export type VoteRoomShutdownSettings = {
  mode: VoteRoomShutdownMode;
  customThreshold: number;
  hours: number;
};

export const DEFAULT_SHUTDOWN_SETTINGS = { mode: 'threshold_75', customThreshold: 90, hours: 48 };

export const SHUTDOWN_MODES = [
  { id: 'threshold_75', label: 'Close at 75% Approval' },
  { id: 'threshold_custom', label: 'Close at Custom Threshold' },
  { id: 'time_based', label: 'Close After Fixed Duration' },
];

/** One-line summary for launch confirmation and live dashboard chrome. */
export function formatShutdownRuleSummary(settings) {
  if (!settings) return '—';
  if (settings.mode === 'threshold_75') return 'Closes at 75% approval';
  if (settings.mode === 'threshold_custom') {
    const pct = settings.customThreshold ?? 90;
    return `Closes at ${pct}% approval`;
  }
  if (settings.mode === 'time_based') {
    const hrs = settings.hours ?? 48;
    return `Closes after ${hrs} hour${hrs === 1 ? '' : 's'}`;
  }
  return '—';
}

/** Build client shutdown settings from persisted analysis fields. */
export function shutdownSettingsFromAnalysis(analysis) {
  const mode = analysis?.voteRoomShutdownMode;
  if (mode === SHUTDOWN_MODE.ThresholdCustom) {
    return {
      mode,
      customThreshold: Number.isFinite(analysis?.voteRoomShutdownCustomThreshold)
        ? analysis.voteRoomShutdownCustomThreshold
        : 90,
      hours: 48,
    };
  }
  if (mode === SHUTDOWN_MODE.TimeBased) {
    return {
      mode,
      customThreshold: 90,
      hours: Number.isFinite(analysis?.voteRoomShutdownHours) ? analysis.voteRoomShutdownHours : 48,
    };
  }
  return { ...DEFAULT_SHUTDOWN_SETTINGS };
}
